import {LottiePlayer} from "@lottiefiles/lottie-player";

export class UcoastLottie extends LottiePlayer {
    constructor() {
        super()

    }
}
